import {
  FaRegDotCircle,
  FaRegStar,


  FaCubes,
} from 'react-icons/fa';
import {
  AiOutlineCluster,


  AiOutlineSetting,
  AiOutlineShoppingCart,
} from 'react-icons/ai';
import {

  FiUsers,

} from 'react-icons/fi';
import {

  BsLightbulb,

} from 'react-icons/bs';
import { CUSTOMER_ROLES } from 'src/shared/constants/AppConst';

const routesConfig = [
  {
    id: 'products',
    title: 'catalog/products',
    messageId: 'catalog.product',
    icon: <FaCubes />,
    type: 'item',
    path: '/catalog/products',
    permissionKey: CUSTOMER_ROLES.ShopAdmin,
  },
  {
    id: 'catalog',
    title: 'catalog',
    messageId: 'Catalog.sideBarName',
    icon: <AiOutlineCluster />,
    type: 'group',
    permissionKey: CUSTOMER_ROLES.Administrators,
    children: [
      {
        id: 'products',
        title: 'catalog/products',
        messageId: 'catalog.product',
        type: 'item',
        path: '/catalog/products',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'categories',
        title: 'catalog/categories',
        messageId: 'catalog.categories',
        type: 'item',
        path: '/catalog/categories',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'product-reviews',
        title: 'catalog/product-reviews',
        messageId: 'catalog.productReviews',
        type: 'item',
        path: '/catalog/product-reviews',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'product-tags',
        title: 'catalog/product-tags',
        messageId: 'catalog.productTags',
        type: 'item',
        path: '/catalog/product-tags',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'product-rejection-reasons',
        title: 'catalog/product-rejection-reasons',
        messageId: 'catalog.productRejectionReasons',
        type: 'item',
        path: '/catalog/product-rejection-reasons',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'catalog.attributes',
        relatedId: 'catalog',
        title: 'catalog/attributes',
        messageId: 'catalog.attributes',
        type: 'group',
        children: [
          {
            id: 'product-attributes',
            title: 'catalog/product-attributes',
            messageId: 'catalog.productAttributes',
            type: 'item',
            path: '/catalog/catalog.attributes/product-attributes',
            permissionKey: CUSTOMER_ROLES.Administrators,
          },
          {
            id: 'specification-attributes',
            title: 'catalog/specification-attributes',
            messageId: 'catalog.specificationAttributes',
            type: 'item',
            path: '/catalog/catalog.attributes/specification-attributes',
            permissionKey: CUSTOMER_ROLES.Administrators,
          },
        ],
      },
    ],
  },
  {
    id: 'customers',
    title: 'customers',
    messageId: 'customers.sideBarName',
    type: 'item',
    icon: <FiUsers />,
    path: '/customers',
    permissionKey: CUSTOMER_ROLES.Administrators,
  },
  {
    id: 'manage-shops',
    title: 'manage-shops',
    messageId: 'manageShops.sideBarName',
    type: 'item',
    icon: <FaRegDotCircle />,
    path: '/manage-shops',
    permissionKey: CUSTOMER_ROLES.Administrators,
  },
  {
    id: 'featured-shops',
    title: 'manage-shops/featured-shops',
    messageId: 'manageShops.featuredShops.sideBarName',
    type: 'item',
    icon: <FaRegStar />,
    path: '/manage-shops/featured-shops',
    permissionKey: CUSTOMER_ROLES.Administrators,
  },
  {
    id: 'shop-details',
    title: 'shop-details',
    messageId: 'manageShops.sideBarName.shopDetails',
    type: 'item',
    icon: <FaRegDotCircle />,
    path: '/shop-details',
    permissionKey: CUSTOMER_ROLES.ShopAdmin,
  },
  {
    id: 'promotions',
    title: 'promotions',
    messageId: 'promotions.sideBarName',
    icon: <BsLightbulb />,
    type: 'group',
    permissionKey: CUSTOMER_ROLES.Administrators,
    children: [
      {
        id: 'banners',
        title: 'promotions/banners',
        messageId: 'promotions.banners',
        type: 'item',
        path: '/promotions/banners',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'general-coupons',
        title: 'promotions/general-coupons',
        messageId: 'promotions.generalCoupons',
        type: 'item',
        path: '/promotions/general-coupons',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'admin-offers',
        title: 'promotions/admin-offers',
        messageId: 'promotions.adminOffers',
        type: 'item',
        path: '/promotions/admin-offers',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'promotions.news-letter',
        title: 'promotions/news-letter',
        messageId: 'promotions.newsLetter',
        type: 'group',
        permissionKey: CUSTOMER_ROLES.Administrators,
        children: [
          {
            id: 'mailing-campaigns',
            title: 'promotions/mailing-campaigns',
            messageId: 'promotions.mailingCampaigns',
            type: 'item',
            path: '/promotions/promotions.news-letter/mailing-campaigns',
            permissionKey: CUSTOMER_ROLES.Administrators,
          },
          {
            id: 'subscribers',
            title: 'promotions/subscribers',
            messageId: 'promotions.subscribers',
            type: 'item',
            path: '/promotions/promotions.news-letter/subscribers',
            permissionKey: CUSTOMER_ROLES.Administrators,
          },
        ],
      },
      {
        id: 'push-campaigns',
        title: 'promotions/push-campaigns',
        messageId: 'promotions.pushCampaigns',
        type: 'item',
        path: '/promotions/push-campaigns',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
    ],
  },
  {
    id: 'configuration',
    title: 'configuration',
    messageId: 'configuration.sideBarName',
    icon: <AiOutlineSetting />,
    type: 'group',
    permissionKey: CUSTOMER_ROLES.Administrators,
    children: [
      {
        id: 'general-configuration',
        title: 'configuration/general-configuration',
        messageId: 'configuration.generalConfiguration',
        type: 'item',
        path: '/configuration/general-configuration',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'brands',
        title: 'configuration/brands',
        messageId: 'configuration.brand',
        type: 'item',
        path: '/configuration/brands',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'countries',
        title: 'configuration/countries',
        messageId: 'configuration.countries',
        type: 'item',
        path: '/configuration/countries',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'languages',
        title: 'configuration/languages',
        messageId: 'configuration.languages',
        type: 'item',
        path: '/configuration/languages',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'currencies',
        title: 'configuration/currencies',
        messageId: 'configuration.currencies',
        type: 'item',
        path: '/configuration/currencies',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'reward-points',
        title: 'configuration/reward-points',
        messageId: 'configuration.rewardPoints',
        type: 'item',
        path: '/configuration/reward-points',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'penalties',
        title: 'configuration/penalties',
        messageId: 'configuration.penalties',
        type: 'item',
        path: '/configuration/penalties',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'email-account',
        title: 'configuration/email-account',
        messageId: 'configuration.emailAccount',
        type: 'item',
        path: '/configuration/email-account',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'order-reasons',
        title: 'configuration/order-reasons',
        messageId: 'orderReasons.sideBar',
        type: 'item',
        path: '/configuration/order-reasons',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
    ],
  },
  {
    id: 'orders',
    title: 'orders',
    messageId: 'orders.sideBarName',
    icon: <AiOutlineShoppingCart />,
    type: 'group',
    permissionKey: [CUSTOMER_ROLES.Administrators, CUSTOMER_ROLES.ShopAdmin],
    children: [
      {
        id: 'orders-list',
        title: 'orders/orders-list',
        messageId: 'orders.sideBarName',
        type: 'item',
        path: '/orders/orders-list',
        permissionKey: [
          CUSTOMER_ROLES.Administrators,
          CUSTOMER_ROLES.ShopAdmin,
        ],
      },
      {
        id: 'return-or-exchange',
        title: 'orders/return-or-exchange',
        messageId: 'orders.returnExchange',
        type: 'item',
        path: '/orders/return-or-exchange',
        permissionKey: [
          CUSTOMER_ROLES.Administrators,
          CUSTOMER_ROLES.ShopAdmin,
        ],
      },
    ],
  },
  {
    id: 'finance',
    title: 'finance',
    messageId: 'finance.sideBarName',
    icon: <AiOutlineShoppingCart />,
    type: 'group',
    permissionKey: [CUSTOMER_ROLES.Administrators, CUSTOMER_ROLES.ShopAdmin],
    children: [
      {
        id: 'transaction',
        title: 'finance/transaction',
        messageId: 'finance.transaction',
        type: 'item',
        path: '/finance/transaction',
        permissionKey: [
          CUSTOMER_ROLES.Administrators,
          CUSTOMER_ROLES.ShopAdmin,
        ],
      },
      {
        id: 'card-payments',
        title: 'finance/card-payments',
        messageId: 'finance.cardPayments',
        type: 'item',
        path: '/finance/card-payments',
        permissionKey: [CUSTOMER_ROLES.Administrators],
      },
    ],
  },
  {
    id: 'policy-management',
    title: 'policy-management',
    messageId: 'policy.sideBarName',
    icon: <FaCubes />,
    type: 'group',
    permissionKey: CUSTOMER_ROLES.Administrators,
    children: [
      {
        id: 'policies',
        title: 'policy/policies',
        messageId: 'policy.policies',
        type: 'item',
        path: '/policy/policies',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
      {
        id: 'policy-tabs',
        title: 'policy/policy-tabs',
        messageId: 'policy.policyTabs',
        type: 'item',
        path: '/policy/policy-tabs',
        permissionKey: CUSTOMER_ROLES.Administrators,
      },
    ],
  },
  // Hidden from shop admins for now, until the shop admin's policies logic is reviewed.
  // The /policies-shop page itself is still routed; restore this entry to show it again.
  // {
  //   id: 'policies-shop',
  //   title: 'policies-shop',
  //   messageId: 'policy.policies',
  //   type: 'item',
  //   icon: <FaCubes />,
  //   path: '/policies-shop',
  //   permissionKey: CUSTOMER_ROLES.ShopAdmin,
  // },
];
export default routesConfig;
